<template>
    <section :class="css.container" ref="container">
        <div :class="css.header">
            <div class="container" :class="css.header_body">
                <h2 :class="css.title" class="font-variable color-1 font-bold">{{ $t("TargetDrug") }}</h2>
                <UiTooltip :zIndex="68" :width="600" direction="bottom" align="start" :classExtraName="css_normalize.tip">
                    <img src="https://rdgta.cdn.cyagen.com/rddc/pictures/ece15431-a9a5-4077-aa2f-e5f560d357c4.webp" alt="" />
                    <template #content>
                        <div :class="css_normalize.context">{{ $t("TargetDrugDescript1") }}</div>
                        <div :class="css_normalize.context">{{ $t("TargetDrugDescript2") }}</div>
                    </template>
                </UiTooltip>
            </div>
        </div>

        <div :class="css.body" class="container" v-loading="loading">
            <div class="text-hint" v-if="!exist">{{ $t("Placeholder.UncollectedData") }}</div>
            <template v-else>
                <div :class="css.controls">
                    <default-search v-model="keyword" :width="376" @search="methods.search" :clearable="true" />
                    <div>
                        <ui-select
                            v-model="status_details"
                            :width="240"
                            :candidates="status"
                            :placeholder="$t('Placeholder.FilterBy')"
                            @change="methods.acquire(1)" />
                        <ui-select
                            v-model="phases_details"
                            :width="240"
                            :candidates="phases"
                            :placeholder="$t('Placeholder.FilterBy')"
                            @change="methods.acquire(1)"
                            :class="css.ml16" />
                    </div>
                </div>

                <!-- * 表格 -->
                <ui-table2 :class="css.table" :data="data" :option="option" :error="$t('NoDataAvailable')">
                    <template #src="{ data }">
                        <ProjectRoute :to="data.src"> {{ $t("View") }}<UiIcon name="export" :class="css.open"></UiIcon> </ProjectRoute>
                    </template>
                </ui-table2>

                <ui-pagination :class="css.pagination" v-model="page" :count="count" @change="methods.acquire()">
                    <template #items> {{ $t("Layout.PaginationDetails", { count: count, limit: 10 }) }}</template>
                </ui-pagination>
            </template>
        </div>
    </section>
</template>

<script lang="ts" setup>
//* 组件库
import { UiPagination, UiSelect, UiTable2, UiTooltip, UiIcon } from "various-ui";
//* 公共组件
import { DefaultSearch } from "@/components/controls";
//* 组件属性
import { useComposable } from "./src/composable";
//* 样式
import css from "./style/index.module.less";
import css_normalize from "@/assets/style/src/index.module.less";

//* 组合函数
const { refs, nodes, option, methods } = useComposable();
const { data, page, exist, count, loading, keyword, phases, status, status_details, phases_details } = refs;
const { container } = nodes;
const { render, hidden } = methods;

//* 组件属性导出
defineExpose({ render, hidden });
</script>
